import {useState} from 'react'
import {addItemToList, addItemsToList, filterList, removeItemFromList} from '../helpers/list'

const useList = ({initialList, defaultSelected = []}) => {
    const [filteredList, setFilteredList] = useState(initialList || [])
    const [selected, setSelected] = useState(defaultSelected)

    const filter = (filterFn) => {
        const filterOriginalList = filterList(initialList)
        const cache = new Map()

        return () => {
            if (!cache.has(filterFn)) {
                cache.set(filterFn, filterOriginalList(filterFn))
            }
            setFilteredList(cache.get(filterFn))
        }
    }

    const addItemToFilteredList = () => {
        const addItem = addItemToList(filteredList)
        return (item) => {
            const updatedList = addItem(item)
            setFilteredList(updatedList)
        }
    }

    const addItemsToSelected = () => {
        return (items) => {
            const addItemsToSelected = addItemsToList(selected)
            const updatedList = addItemsToSelected(items)
            setSelected(updatedList)
        }
    }
    const addItemToSelected = () => {
        const addItem = addItemToList(selected)
        return (item) => {
            const updatedList = addItem(item)
            setSelected(updatedList)
        }
    }

    const removeItemFromSelected = () => {
        const removeItem = removeItemFromList(selected)
        return (itemId) => {
            const updatedList = removeItem(itemId)
            setSelected(updatedList)
        }
    }

    const removeItemFromFilteredList = () => {
        const removeItem = removeItemFromList(filteredList)
        return (itemId) => {
            const updatedList = removeItem(itemId)
            setFilteredList(updatedList)
        }
    }

    const unselectAll = (filteredList) => {
        return () => {
            setSelected((prevSelected) => prevSelected.filter((item) => !filteredList.some((f) => f.id === item.id)))
        }
    }

    const selectAll = () => {
        setSelected(filteredList)
    }

    const isSelected = (itemId) => {
        return selected.some((item) => item.id === itemId)
    }
    const isSelectedAll = () => {
        return filteredList.length > 0 && filteredList.every((item) => isSelected(item.id))
    }

    return {
        onFilterList: filter,
        onAddItemToSelected: addItemToSelected(),
        addItemToFilteredList: addItemToFilteredList(),
        onAddItemsToSelected: addItemsToSelected(),
        onUpdateSelected: setSelected,
        onUpdateFilteredList: setFilteredList,
        onRemoveItemFromSelected: removeItemFromSelected(),
        onRemoveItemFromFilteredList: removeItemFromFilteredList(),
        selectAll,
        unSelectAll: unselectAll(filteredList),
        selected,
        filteredList,
        isSelected,
        isSelectedAll: isSelectedAll(),
    }
}

export default useList
